var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "12" } },
        [
          _c("w-input", {
            attrs: { label: _vm.$ct("text"), fancy: "", required: "" },
            model: {
              value: _vm.value.Text,
              callback: function ($$v) {
                _vm.$set(_vm.value, "Text", $$v)
              },
              expression: "value.Text",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "12" } },
        [
          _c(
            "w-row",
            _vm._l(_vm.fullAssignedUsers, function (user, i) {
              return _c(
                "w-chip",
                {
                  key: user.ID,
                  attrs: { active: "", closable: "" },
                  on: {
                    close: function ($event) {
                      return _vm.removeUser(i)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(user.getShortDisplayName()) + " ")]
              )
            }),
            1
          ),
          _c(
            "w-row",
            { staticClass: "mts" },
            [
              _c("app-user-search", {
                staticStyle: { "flex-grow": "1" },
                attrs: {
                  users: _vm.addableUsers,
                  fancy: "",
                  label: _vm.$ct("assign-user"),
                },
                on: {
                  input: function ($event) {
                    return _vm.addUser($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c(
            "w-row",
            [
              _c("w-date-picker", {
                style: { flexGrow: 1 },
                attrs: {
                  "min-date": _vm.minDate,
                  value: _vm.value.DueDate,
                  fancy: "",
                  label: _vm.$ct("due-date"),
                  "disabled-attributes": _vm.wAttributes,
                  nullable: "",
                },
                on: {
                  input: function ($event) {
                    _vm.value.DueDate = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-select", {
            attrs: {
              items: _vm.taskStatuses,
              fancy: "",
              label: _vm.$ct("status"),
            },
            model: {
              value: _vm.value.Status,
              callback: function ($$v) {
                _vm.$set(_vm.value, "Status", $$v)
              },
              expression: "value.Status",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-select", {
            attrs: {
              items: _vm.folderItems,
              fancy: "",
              label: _vm.$ct("folder"),
            },
            model: {
              value: _vm.value.FolderID,
              callback: function ($$v) {
                _vm.$set(_vm.value, "FolderID", $$v)
              },
              expression: "value.FolderID",
            },
          }),
        ],
        1
      ),
      _c(
        "w-col",
        { staticClass: "mts", attrs: { xs: "12" } },
        [
          _c("app-task-priority-chips", {
            attrs: { label: _vm.$ct("priority") },
            model: {
              value: _vm.value.Priority,
              callback: function ($$v) {
                _vm.$set(_vm.value, "Priority", $$v)
              },
              expression: "value.Priority",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }